/** Build-time version from package.json (vite `define`). */
export const APP_VERSION = __APP_VERSION__;
